import { Trophy, Award, Star } from "lucide-react"

interface Achievement {
  title: string
  description: string
  icon: "trophy" | "award" | "star"
  color: string
}

interface AchievementsCardProps {
  achievements: Achievement[]
}

export function AchievementsCard({ achievements }: AchievementsCardProps) {
  const iconMap = {
    trophy: Trophy,
    award: Award,
    star: Star,
  }

  const colorMap: Record<string, { bg: string; text: string }> = {
    yellow: { bg: "bg-yellow-100", text: "text-yellow-700" },
    blue: { bg: "bg-blue-100", text: "text-blue-700" },
    teal: { bg: "bg-teal-100", text: "text-teal-700" },
  }

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5">
      <div className="flex items-center gap-2 mb-4">
        <Trophy className="w-5 h-5 text-teal-500" />
        <h3 className="font-bold text-gray-900 text-base">Key Achievements</h3>
      </div>

      <ul className="space-y-3">
        {achievements.map((achievement, index) => {
          const Icon = iconMap[achievement.icon]
          const colors = colorMap[achievement.color]

          return (
            <li key={index} className="flex gap-3 items-start p-2 rounded-lg hover:bg-gray-50 transition-colors">
              <div
                className={`mt-0.5 w-5 h-5 rounded ${colors.bg} flex items-center justify-center shrink-0 ${colors.text}`}
              >
                <Icon className="w-3.5 h-3.5" />
              </div>
              <div>
                <p className="text-xs font-bold text-gray-900">{achievement.title}</p>
                <p className="text-[10px] text-gray-500 leading-tight mt-0.5">{achievement.description}</p>
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
